/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IMapHierarchyItem } from '../../core/models';

export class GeofenceMandatoryGroupsValidator {
  static createValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control.value as IMapHierarchyItem[];
      return !!value && value.length > 0 ? null : { invalidMandatoryGroups: true };
    };
  }
}
